import Focus from './Focus.vue';

export default Focus;
